import React from "react";
import styles from "./ToastContent.module.scss";
import ErrorIcon from "../../assets/images/ErrorToastIcon.png";
import SuccessIcon from "../../assets/images/Success_check.svg";
import PropTypes from 'prop-types';

const ToastContent = ({ status, message }) => (
  <div className={styles["customtoast-content"]}>
    <img
      src={status ? SuccessIcon : ErrorIcon}
      alt="custom-success-icon"
      className={styles["customtoast-icon"]}
    />
    <div className={styles["customtoast-message"]}>
      <p>{message}</p>
    </div>
  </div>
);

ToastContent.propTypes = {
  status: PropTypes.bool,
  message: PropTypes.string
}

export default ToastContent;
